export const serviceQuota = {
  zh: {
    title: "訂閱方案以解鎖內容",
  },
  en: {
    title: "Browsing restrictions can be lifted for a fee.",
  },
};
